<template>
	<div v-loading="fullLoading">
		<list-template
			ref="listDom"
			:loading="loading"
			:is-download="true"
			:search-config="searchConfig"
			:is-check-input-box="false"
			@onSearch="onSearch"
			:table-config="tableConfigList"
			:table-data="tableData"
			:total="total"
			:current-page="page"
			:events="{ 'selection-change': onSelectionChange }"
			@onChangePage="handleCurrentChange"
			@onHandle="handleEdit"
			@onExportData="onDownload"
			@onLeaveJobs="handleVisible(1)"
			@onAutoAllocate="handleSelect"
			@onStartAllocate="handleVisible(2)"
			:isDisabled="{ startAllocate: buttonIsDisable }"
			:isHide="{ startAllocate: !isCanSelect }"></list-template>
		<Dialog :visible.sync="dialogVisible" :title="title" :showClose="false" :showFooter="false" :closeOnClickModal="false">
			<el-form ref="form" :model="formData" :rules="rules" label-width="140rem">
				<el-form-item label="已离职老师归属" prop="resignation" v-if="dialogVisible1">
					<el-radio-group v-model="formData.resignation" @change="handleChange">
						<el-radio label="1">招生老师</el-radio>
						<el-radio label="2">内推老师</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="已离职老师" v-if="dialogVisible1" required>
					<div v-if="Number(formData.resignation) == 2" style="display: flex; align-items: center">
						<el-form-item prop="diy_sign_teacher_name_from" :inline="true" :label-width="0">
							<el-select
								v-model="formData.diy_sign_teacher_name_from"
								@change="handleChangeTeacher"
								filterable
								remote
								reserve-keyword
								placeholder="请搜素内推老师姓名"
								:remote-method="(e) => handleRemote_(e, 1)"
								:loading="remoteLoading1">
								<el-option v-for="item in options1_" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
						</el-form-item>
						-
						<el-form-item prop="diy_school_from" :inline="true" :label-width="0">
							<el-select v-model="formData.diy_school_from" disabled filterable remote reserve-keyword placeholder="内推老师所属校区/部门 " :loading="remoteLoading1">
								<el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
						</el-form-item>
					</div>
					<div v-else>
						<el-form-item prop="chg_teacher_from" :label-width="0">
							<el-select v-model="formData.chg_teacher_from" filterable remote reserve-keyword placeholder="请搜索" :remote-method="(e) => handleRemote(e, 1)" :loading="remoteLoading1">
								<el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
						</el-form-item>
					</div>
				</el-form-item>
				<el-form-item label="转移交接人归属" prop="handover" required>
					<el-radio-group v-model="formData.handover" @change="handleChange">
						<el-radio label="1">招生老师</el-radio>
						<el-radio label="2">内推老师</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="转移交接人" required>
					<div v-if="Number(formData.handover) == 2" style="display: flex; align-items: center">
						<el-form-item prop="diy_sign_teacher_name_to" :inline="true" :label-width="0">
							<el-input v-model="formData.diy_sign_teacher_name_to" maxlength="30" placeholder="请输入内推老师姓名"></el-input>
						</el-form-item>
						-
						<el-form-item prop="diy_school_to" :inline="true" :label-width="0">
							<el-input v-model="formData.diy_school_to" maxlength="30" placeholder="请输入内推老师所属校区部门"></el-input>
						</el-form-item>
					</div>
					<div v-else>
						<el-form-item prop="chg_teacher_to" :label-width="0">
							<el-select v-model="formData.chg_teacher_to" filterable remote reserve-keyword placeholder="请搜索" :remote-method="(e) => handleRemote(e, 2)" :loading="remoteLoading2">
								<el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
						</el-form-item>
					</div>
				</el-form-item>
				<el-form-item style="text-align: center" label-width="0">
					<el-button :loading="dialogLoading" type="primary" @click="handleSubmit('form')">提交</el-button>
					<el-button :disabled="dialogLoading" @click="handleVisible(0)">取消</el-button>
				</el-form-item>
			</el-form>
		</Dialog>
		<Dialog :visible.sync="dialogVisible3" title="提示" size="small" :showClose="false" :showFooter="false" :closeOnClickModal="false">
			<div class="dialog-box flex-center" v-if="dialogLoading">
				<div>数据正在处理中 ...</div>
			</div>
			<div class="dialog-box flex flex-column justify-between" v-else>
				<div class="px-5 t-c">共有【{{ info.count }}】个订单将{{ info.name1 ? `由【${info.name1}】` : "" }}交接给【{{ info.name2 }}】 是否继续操作？</div>
				<div class="flex-center">
					<el-button type="primary" @click="handleSure">开始分配</el-button>
					<el-button @click="handleVisible(3)">取消</el-button>
				</div>
			</div>
		</Dialog>
	</div>
</template>
<script>
import { mapState } from "vuex";
import Dialog from "@/components/common/Dialog";
import LineWrapper from "@/components/common/LineWrapper";
import LineItem from "@/components/common/LineItem";
import tools from "@/utils/tools";
import { setConfigOption } from "@/utils";
import { get_grade_zs, get_recruit_teacher, get_recruit_count, edit_belong_teacher, zsGet, get_recruit_dict, get_recruit_teacher_, get_recruit_count_ } from "@/api";
export default {
	_config: { route: { path: "list", meta: { title: "列表", keepAlive: true } } },
	components: { Dialog, LineWrapper, LineItem },
	data() {
		return {
			loading: false,
			search: {},
			searchConfig: [
				{
					prop: "order_status",
					tag: "select",
					placeholder: "筛选订单状态",
					options: [
						{ label: "待支付", value: 1 },
						{ label: "已支付", value: 2 },
						{ label: "已取消", value: 3 }
					]
				},
				{
					prop: "school_id",
					tag: "select",
					placeholder: "筛选就读校区",
					label: "school_name",
					value: "id",
					options: []
				},
				{
					prop: "grade_id",
					tag: "select",
					placeholder: "筛选年级",
					options: []
				},
				{
					prop: "student_status",
					tag: "select",
					placeholder: "筛选学生状态",
					options: []
				},
				{
					prop: "is_baoben",
					tag: "select",
					placeholder: "筛选是否参与保本协议",
					options: [
						{ label: "是", value: 1 },
						{ label: "否", value: 0 }
					]
				},
				{
					prop: "sign_status",
					tag: "select",
					placeholder: "筛选签约状态",
					options: [
						{ label: "待签约", value: 1 },
						{ label: "已签约", value: 2 },
						{ label: "-", value: 101 }
					]
				},
				{ prop: "is_by_stages", tag: "select", placeholder: "筛选学生是否分期" },
				{
					prop: "time",
					tag: "daterange",
					start: "创建订单时间",
					rangeText: "-"
				},
				{
					prop: "student_name",
					placeholder: "搜索学生姓名"
				},
				{
					prop: "customer_name",
					placeholder: "搜索家长姓名"
				},
				{
					prop: "belong_teacher_name",
					placeholder: "搜索客户归属人"
				}
			],

			tableData: [],
			//总条数
			total: 0,
			pageCount: 0,
			tableConfig: [
				{ prop: "order_status", label: "订单状态" },
				{ prop: "student_status_cn", label: "学生状态" },
				{ prop: "student_name", label: "学生姓名" },
				{ prop: "customer_name", label: "家长姓名" },
				{ prop: "school", label: "实际就读学校" },
				{ prop: "grade_name", label: "报名年级" },
				{ prop: "belong_teacher_name", label: "客户归属人", render: (row) => `<span class="${row.teacher_status ? "" : "text-gray"}">${row.belong_teacher_name}</span>` },
				{ prop: "is_baoben_name", label: "是否参与保本协议" },
				{ prop: "sign_status", label: "签约状态" },
				{ prop: "is_by_stages_name", label: "学生是否分期" },
				{ prop: "created_at", label: "创建订单时间" },
				{ prop: "handle", label: "操作", width: "200rem", handle: true }
			],

			historyDialogShow: false,
			historyList: [],
			formData: {
				chg_teacher_from: "",
				chg_teacher_to: "",
				handover: "1",
				resignation: "1",
				diy_sign_teacher_name_from: "",
				diy_school_from: "",
				diy_sign_teacher_name_to: "",
				diy_school_to: ""
			},
			rules: {
				resignation: [{ required: true, message: "请选择已离职老师归属", trigger: "change" }],
				chg_teacher_from: [
					{
						validator: (rule, value, callback) => {
							// 当选择招生老师时的验证
							if (Number(this.formData.resignation) !== 2 && !value) {
								return callback(new Error("请选择招生老师"));
							}
							callback();
						},
						trigger: "change"
					}
				],
				handover: [{ required: true, message: "请选择转移交接人归属", trigger: "change" }],
				chg_teacher_to: [
					{
						validator: (rule, value, callback) => {
							// 当选择招生老师时的验证
							if (Number(this.formData.handover) !== 2 && !value) {
								return callback(new Error("请选择招生老师"));
							}
							callback();
						},
						trigger: ["change", "blur"]
					}
				],
				// 内推老师相关字段的验证规则，根据条件动态设置required
				diy_sign_teacher_name_from: [
					{
						required: function () {
							return Number(this.formData.resignation) === 2;
						},
						message: "请选择内推老师姓名",
						trigger: "change"
					}
				],
				diy_school_from: [
					{
						required: function () {
							return Number(this.formData.resignation) === 2;
						},
						message: "请选择内推老师所属校区/部门",
						trigger: "change"
					}
				],
				diy_sign_teacher_name_to: [
					{
						required: function () {
							return Number(this.formData.handover) === 2;
						},
						message: "请输入内推老师姓名",
						trigger: ["change", "blur"]
					}
				],
				diy_school_to: [
					{
						required: function () {
							return Number(this.formData.handover) === 2;
						},
						message: "请输入内推老师所属校区部门",
						trigger: ["change", "blur"]
					}
				]
			},
			title: "",
			isCanSelect: false,
			fullLoading: false,
			dialogLoading: false,
			dialogVisible1: false,
			dialogVisible2: false,
			dialogVisible3: false,
			remoteLoading1: false,
			remoteLoading2: false,
			options1: [],
			options1_: [],
			options2: [],
			info: {},
			selectionData: []
		};
	},
	created() {
		this.$store.commit("setPage", 1);
		this.getData();
		this.getSchool();
		this.getConfig();
	},
	activated() {
		this.getData();
	},
	computed: {
		...mapState(["page"]),
		tableConfigList() {
			const arr = this.tableConfig.map((i) => ({ ...i }));
			if (this.isCanSelect) arr.unshift({ type: "selection" });
			return arr;
		},
		dialogVisible() {
			return this.dialogVisible1 || this.dialogVisible2;
		},
		buttonIsDisable() {
			if (!this.isCanSelect || !this.selectionData.length) return true;
			return false;
		}
	},
	methods: {
		getConfig() {
			get_recruit_dict().then((res) => {
				setConfigOption({ list: this.searchConfig, data: res.diff_fee, key: "diff_fee_status" });
				setConfigOption({ list: this.searchConfig, data: res.order_stages_list, key: "is_by_stages" });
			});
			get_grade_zs().then((res) => {
				setConfigOption({ list: this.searchConfig, data: res, key: "grade_id", label: "name", value: "id" });
			});
			zsGet("/recruit/fresh-graduate/student-status").then((data) => {
				const list = Object.keys(data).map((item) => ({ label: data[item], value: Number(item), disabled: true }));
				setConfigOption({ list: this.searchConfig, data: list, key: "student_status" });
			});
		},
		getData() {
			if (this.loading) return;
			this.loading = true;
			let params = { ...JSON.parse(JSON.stringify(this.search)), page: this.page, order_type: 2 };
			if (params.time && params.time.length) {
				params.start_created_at = params.time[0];
				params.end_created_at = params.time[1];
				delete params.time;
			}
			this.tableData = [];
			this.$_register("api/recruit/fresh-graduate/index", { params })
				.then((res) => {
					let data = res.data.data;
					this.tableData = data.list;
					this.total = data.page.total;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		// 校区数据获取
		getSchool() {
			this.$_register("api/recruit/common/consulting-school").then((res) => {
				this.searchConfig[1].options = res.data.data.entity_school || [];
			});
		},

		onSearch(val) {
			this.$store.commit("setPage", 1);
			this.search = val;
			this.getData(val);
		},

		handleEdit(row, text) {
			const num = Number(row.school_year);
			if (text.type.includes("edit")) {
				this.$router.push(`./edit${num > 2023 ? "2" : ""}?id=${row.id}${text.type === "senior_edit" ? "&type=senior" : ""}`);
			}

			if (text.type === "view") {
				this.$router.push(`./detail${num < 2024 ? "s" : ""}?id=${row.id}`);
			}
		},

		// 当前页改变触发
		handleCurrentChange(val) {
			//当前页赋值给currentPage
			this.$store.commit("setPage", val);
			//拉取数据
			this.getData();
		},

		onDownload() {
			let params = { ...JSON.parse(JSON.stringify(this.search)), page: this.page, order_type: 2 };
			if (params.time && params.time.length) {
				params.start_created_at = params.time[0];
				params.end_created_at = params.time[1];
				delete params.time;
			}
			this.$_register("api/recruit/fresh-graduate/export-v2", { params, timeout: 0 }).then((res) => {
				tools.download("应届生报名", res.data);
			});
		},
		handleRemote(query, index) {
			if (query) {
				this[`remoteLoading${index}`] = true;
				const data = { name: query };
				if (index === 2) data.status = 1;
				get_recruit_teacher(data)
					.then((res) => {
						this[`options${index}`] = res.map((item) => {
							return { value: item.id, label: `${item.name}(${item.username})`, name: item.name };
						});
					})
					.finally(() => {
						this[`remoteLoading${index}`] = false;
					});
			} else {
				this[`options${index}`] = [];
			}
		},
		handleRemote_(query, index) {
			if (query) {
				this[`remoteLoading${index}`] = true;
				const data = { keyword: query, order_type: 2 };
				if (index === 2) data.status = 1;
				get_recruit_teacher_(data)
					.then((res) => {
						this.options1_ = res.map((item) => {
							return { value: item.diy_sign_teacher_name, label: `${item.diy_sign_teacher_name}`, name: item.diy_school };
						});
					})
					.finally(() => {
						this[`remoteLoading${index}`] = false;
					});
			} else {
				this.options1_ = [];
			}
		},
		/**
		 * 处理resignation和handover值变化的方法
		 * 用于清空相关字段的值和验证状态
		 * @returns {void}
		 */
		handleChange() {
			// 清空已离职老师相关字段
			if (this.$refs.form) {
				this.$refs.form.clearValidate();
			}
		},
		/**
		 * 处理内推老师选择变化的方法
		 * @param {string} val - 选择的内推老师姓名
		 * @returns {void}
		 */
		handleChangeTeacher(val) {
			console.log(val);
			const selectedItem = this.options1_.find((item) => item.value === val);
			if (selectedItem) {
				this.formData.diy_school_from = selectedItem.name;
			}
		},
		/**
		 * 初始化表单数据的方法
		 * @returns {void}
		 */
		handleInit() {
			this.formData = {
				chg_teacher_from: "",
				chg_teacher_to: "",
				handover: "",
				resignation: "",
				diy_sign_teacher_name_from: "",
				diy_school_from: "",
				diy_sign_teacher_name_to: "",
				diy_school_to: ""
			};
			this.info = {};
		},
		handleVisible(type) {
			if (!type) type = this.type;
			if (type === 2 && !this.selectionData.length) {
				return this.$message({ type: "warning", message: "请选择数据" });
			}
			this[`dialogVisible${type}`] = !this[`dialogVisible${type}`];
			if (!this[`dialogVisible${type}`]) return this.handleInit();
			this.options1 = [];
			this.options2 = [];
			if (type === 1) {
				this.title = "离职交接";
				this.formData.handover = "1";
				this.formData.resignation = "1";
			} else if (type === 2) this.title = "准备开始分配";
			this.type = type;
		},
		/**
		 * 提交表单的方法
		 * @param {string} name - 表单引用名称
		 * @returns {void}
		 */
		handleSubmit(name) {
			this.$refs[name].validate((valid) => {
				if (valid) {
					const info = {};
					// 处理交接人信息
					if (Number(this.formData.handover) === 2) {
						info.name2 = this.formData.diy_sign_teacher_name_to;
					} else {
						const selectedTo = this.options2.find((item) => item.value === this.formData.chg_teacher_to);
						info.name2 = selectedTo ? selectedTo.name : "";
					}

					if (this.type === 1) {
						// 处理离职老师信息
						if (Number(this.formData.resignation) === 2) {
							info.name1 = this.formData.diy_sign_teacher_name_from;
						} else {
							const selectedFrom = this.options1.find((item) => item.value === this.formData.chg_teacher_from);
							info.name1 = selectedFrom ? selectedFrom.name : "";
						}
					} else if (this.type === 2) {
						info.count = this.selectionData.length;
						this.info = info;
						this[`dialogVisible${this.type}`] = false;
						this.dialogVisible3 = true;
						return;
					}

					// 只有在离职交接模式下才需要获取订单数量
					if (this.type === 1) {
						// 如果是内推老师，可能需要特殊处理count逻辑
						if (Number(this.formData.resignation) === 2) {
							get_recruit_count_({ diy_sign_teacher_name: this.formData.diy_sign_teacher_name_from, diy_school: this.formData.diy_school_from, timeout: 0, order_type: 2 }).then((res) => {
								const { order_num } = res;
								if (order_num === 0) {
									return this.$message({ type: "warning", message: "该老师没有报名数据，请重新选择", duration: 3500 });
								}
								this[`dialogVisible${this.type}`] = false;
								this.dialogVisible3 = true;
								info.count = order_num;
								this.info = info;
							});
						} else {
							get_recruit_count({ belong_teacher_id: this.formData.chg_teacher_from, order_type: 2 }).then((res) => {
								const { order_num } = res;
								if (order_num === 0) {
									return this.$message({ type: "warning", message: "该老师没有报名数据，请重新选择", duration: 3500 });
								}
								this[`dialogVisible${this.type}`] = false;
								this.dialogVisible3 = true;
								info.count = order_num;
								this.info = info;
							});
						}
					}
				}
			});
		},
		/**
		 * 确认操作的方法
		 * @returns {void}
		 */
		handleSure() {
			this.fullLoading = true;
			this.dialogVisible3 = false;
			const data = {
				chg_type: this.type - 1,
				handover: this.formData.handover, // 确保handover字段被包含在提交数据中
				resignation: this.formData.resignation, // 确保resignation字段被包含在提交数据中
				order_type: 2
			};

			// 处理交接人信息
			if (Number(this.formData.handover) === 2) {
				data.diy_sign_teacher_name_to = this.formData.diy_sign_teacher_name_to;
				data.diy_school_to = this.formData.diy_school_to;
			} else {
				data.chg_teacher_to = this.formData.chg_teacher_to;
			}

			// 处理离职老师信息（仅在离职交接模式下）
			if (this.type === 1) {
				if (Number(this.formData.resignation) === 2) {
					data.diy_sign_teacher_name_from = this.formData.diy_sign_teacher_name_from;
					data.diy_school_from = this.formData.diy_school_from;
				} else {
					data.chg_teacher_from = this.formData.chg_teacher_from;
				}
			}
			// 处理批量分配模式
			else if (this.type === 2) {
				data.order_ids = this.selectionData.join(",");
			}

			edit_belong_teacher(data, { timeout: 0 })
				.then((res) => {
					this.$message({ type: "success", message: "处理成功", duration: 3500 });
					this.isCanSelect = false;
					this.selectionData = [];
					this.getData();
				})
				.finally(() => {
					this.fullLoading = false;
					this.handleInit();
				});
		},
		handleSelect() {
			this.isCanSelect = !this.isCanSelect;
		},
		onSelectionChange(e) {
			this.selectionData = e.map((item) => item.id);
		}
	}
};
</script>
<style lang="scss" scoped>
::v-deep .el-date-editor .el-range-separator {
	padding: 0 !important;
	width: 0 !important;
}
.dialog-box {
	height: 120rem;
}
</style>
